import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import KnowledgeCard from './KnowledgeCard';
import { KnowledgeData } from './KnowledgeData';

const Knowledge = () => {
  // Organize data by categories for the two rows
  const blogItems = KnowledgeData.filter(item => item.category === 'Blogs');
  const trendsItems = KnowledgeData.filter(item => item.category === 'Trends, Q&A');
  const learningItems = KnowledgeData.filter(item => item.category === 'Learning Center');
  const podcastItems = KnowledgeData.filter(item => item.category === 'Podcast');

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full p-6">
        <div className="space-y-16">
          {/* First Row: Blogs (2/3) and Trends Q&A (1/3) */}
          <div className="flex flex-col md:flex-row md:gap-8">
            {/* Blogs Section - 2/3 width */}
            <div className="w-full md:w-2/3 mb-10 md:mb-0">
              <h2 className="text-[#D47600] heading text-xl md:text-xl lg:text-2xl font-bold mb-4">Blogs</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {blogItems.map(item => (
                  <KnowledgeCard
                    key={item.id}
                    title={item.title}
                    description={item.description}
                    Icon={item.Icon}
                    externalLink={item.externalLink}
                  />
                ))}
              </div>
            </div>
            
            {/* Trends, Q&A Section - 1/3 width */}
            <div className="w-full md:w-1/3">
              <h2 className="text-[#D47600] heading text-xl md:text-xl lg:text-2xl font-bold mb-4">Trends, Q&A</h2>
              <div className="grid grid-cols-1 gap-6">
                {trendsItems.map(item => (
                  <KnowledgeCard
                    key={item.id}
                    title={item.title}
                    description={item.description}
                    Icon={item.Icon}
                    externalLink={item.externalLink}
                  />
                ))}
              </div>
            </div>
          </div>
          
          {/* Second Row: Learning Center (2/3) and Podcast (1/3) */}
          <div className="flex flex-col md:flex-row md:gap-8">
            {/* Learning Center Section - 2/3 width */}
            <div className="w-full md:w-2/3 mb-10 md:mb-0">
              <h2 className="text-[#D47600] heading text-xl md:text-xl lg:text-2xl font-bold mb-4">Learning Center</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {learningItems.map(item => (
                  <KnowledgeCard
                    key={item.id}
                    title={item.title}
                    description={item.description}
                    Icon={item.Icon}
                    externalLink={item.externalLink}
                  />
                ))}
              </div>
            </div>
            
            {/* Podcast Section - 1/3 width */}
            <div className="w-full md:w-1/3">
              <h2 className="text-[#D47600] heading text-xl md:text-xl lg:text-2xl font-bold mb-4">Podcast</h2>
              <div className="grid grid-cols-1 gap-6">
                {podcastItems.map(item => (
                  <KnowledgeCard
                    key={item.id}
                    title={item.title}
                    description={item.description}
                    Icon={item.Icon}
                    externalLink={item.externalLink}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Knowledge;